export type TermsGroupKey = "payment" | "tipping" | "travel" | "other";

export const TERMS_GROUP_TITLES: Record<TermsGroupKey, string> = {
  payment: "Payment Terms",
  tipping: "Tipping & Gratuities",
  travel: "Important Travel Information",
  other: "Additional Terms",
};

const TIPPING = /\b(tip|tips|tipping|gratuit)/i;
const TRAVEL = /\b(visa|passport|insurance|force majeure|liab|third[- ]party|weather|vaccin|health)/i;
const PAYMENT = /\b(pay|payment|deposit|balance|refund|cancel|no[- ]show|invoice|usd|zar|currency|price|rate|quote|amendment|fee)/i;

export function classifyTermLine(line: string): TermsGroupKey {
  if (TIPPING.test(line)) return "tipping";
  if (TRAVEL.test(line)) return "travel";
  if (PAYMENT.test(line)) return "payment";
  return "other";
}

/** Splits the flat stored terms text into ordered, non-empty groups. */
export function groupTerms(text: string | null | undefined) {
  const groups: Record<TermsGroupKey, string[]> = { payment: [], tipping: [], travel: [], other: [] };
  for (const raw of (text || "").split("\n")) {
    const line = raw.trim();
    if (!line) continue;
    groups[classifyTermLine(line)].push(line);
  }
  return (["payment", "tipping", "travel", "other"] as TermsGroupKey[])
    .filter((k) => groups[k].length > 0)
    .map((k) => ({ key: k, title: TERMS_GROUP_TITLES[k], lines: groups[k] }));
}
